import { useApi } from '@/composables/useApi'

const api = useApi()

export function RdStationService() {
  this.deleteRdStation = function (rdStationId) {
    return new Promise((resolve, reject) => {
      try {
        api.delete(`Integracoes/${rdStationId}`)
          .then(resp => {
            resolve(resp.data[0])
          })
      } catch (error) {
        reject(error)
      }
    })
  }
}
